const localeContext = require.context('../../i18n/tr', false, /\.json$/)
const sharedContext = require.context('../../i18n', false, /cross_locale\.json$/)

window.HCM_I18N_TRANSLATIONS = [localeContext, sharedContext].flatMap((context) => context.keys().map((key) => context(key)))
window.HCM_DATE_FNS_LOCALES = { tr: require('date-fns/locale/tr').tr }
